export default __webpack_public_path__ + "static/media/productList1.3fa77a51.png";